<div class="relative grid grid-cols-1 justify-items-center gap-8 rounded-xl bg-white p-8 shadow-lg select-none">
  <h2 class="font-family-din text-center text-xl font-medium">Nauwkeurigheid</h2>
  <div class="flex gap-4">
    @let _rating = rating();
    <rid-rating-star label="enkele goed" [filled]="typeof _rating === 'number' && _rating >= 0" (click)="rate(0)" />
    <rid-rating-star label="gedeelte goed" [filled]="typeof _rating === 'number' && _rating >= 1" (click)="rate(1)" />
    <rid-rating-star label="merendeel goed" [filled]="typeof _rating === 'number' && _rating >= 2" (click)="rate(2)" />
    <rid-rating-star label="bijna alles goed" [filled]="typeof _rating === 'number' && _rating >= 3" (click)="rate(3)" />
    <rid-rating-star label="alles goed" [filled]="typeof _rating === 'number' && _rating >= 4" (click)="rate(4)" />
  </div>
  <div class="grid w-max grid-cols-2 gap-4">
    <rid-button content="Terug" variant="SECONDARY" [disabled]="_rating === undefined" (click)="canceled.emit()" />
    <rid-button content="Volgende" [disabled]="_rating === undefined" (click)="continued.emit()" />
  </div>
</div>
